var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-wrapper", class: _vm.classObj },
    [
      _vm.device === "mobile" && _vm.sidebar.opened
        ? _c("div", {
            staticClass: "drawer-bg",
            on: { click: _vm.handleClickOutside }
          })
        : _vm._e(),
      [
        _vm.menuRefreshId % 2 === 0
          ? _c("sidebar", {
              staticClass: "sidebar-container",
              attrs: { id: "sidebar-container" }
            })
          : _c("sidebar", {
              staticClass: "sidebar-container",
              attrs: { id: "sidebar-container" }
            })
      ],
      _c(
        "div",
        {
          staticClass: "main-container",
          class: { hasTagsView: _vm.needTagsView }
        },
        [
          _c(
            "div",
            { class: { "fixed-header": _vm.fixedHeader } },
            [
              _c("navbar", { ref: "navbar" }),
              _vm.needTagsView ? _c("tags-view") : _vm._e()
            ],
            1
          ),
          _c("app-main", {
            attrs: { id: "app-main" },
            on: { openSysMsg: _vm.openSysMsg }
          }),
          false ? _c("right-panel", [_c("settings")], 1) : _vm._e()
        ],
        1
      ),
      _c("cargo-ai-host"),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.isShowingChangePasswordDialog,
            title: _vm.$t("Message.ChangePassword"),
            width: "420px"
          },
          on: {
            "update:visible": function($event) {
              _vm.isShowingChangePasswordDialog = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                "label-width": "100px",
                "label-position": "left",
                size: "mini"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Message.OriginalPassword") } },
                [
                  _c("el-input", {
                    attrs: { type: "password" },
                    model: {
                      value: _vm.oldPassword,
                      callback: function($$v) {
                        _vm.oldPassword = $$v
                      },
                      expression: "oldPassword"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-top": "16px" },
                  attrs: { label: _vm.$t("Message.NewPassword") }
                },
                [
                  _c("el-input", {
                    attrs: { type: "password" },
                    model: {
                      value: _vm.newPassword,
                      callback: function($$v) {
                        _vm.newPassword = $$v
                      },
                      expression: "newPassword"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-top": "16px" },
                  attrs: { label: _vm.$t("Message.ConfirmPassword") }
                },
                [
                  _c("el-input", {
                    attrs: { type: "password" },
                    model: {
                      value: _vm.newPasswordAgain,
                      callback: function($$v) {
                        _vm.newPasswordAgain = $$v
                      },
                      expression: "newPasswordAgain"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: {
                    "margin-top": "16px",
                    display: "flex",
                    "justify-content": "flex-end"
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.toChangePassword }
                    },
                    [_vm._v(_vm._s(_vm.$t("Payment.edit")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.isShowingChangePasswordDialog = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }